import { render, staticRenderFns } from "./storeReturnAudit.vue?vue&type=template&id=164aaaba&scoped=true"
import script from "./storeReturnAudit.vue?vue&type=script&lang=js"
export * from "./storeReturnAudit.vue?vue&type=script&lang=js"
import style0 from "./storeReturnAudit.vue?vue&type=style&index=0&id=164aaaba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164aaaba",
  null
  
)

export default component.exports